
import {
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
} from "./../Constants/UserConstaint";
// LOGIN
export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};


// ALL user
export const userListReducer = (state = {users:[]}, action) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return { loading: true };
    case USER_LIST_SUCCESS:
      return { loading: false, users: action.payload };
    case USER_LIST_FAIL:
      return { loading: false, error: action.payload };
    case USER_LIST_RESET:
      return {users:[]};
    default:
      return state;
  }
};



// // USER DETAILS
// export const userDetailsReducer = (state = {user:{}}, action) => {
//   switch (action.type) {
//     case USER_DETAILS_REQUEST:
//       return { ...state,loading: true };
//     case USER_DETAILS_SUCCESS:
//       return { loading: false, user: action.payload };
//     case USER_DETAILS_FAIL:
//       return { loading: false, error: action.payload };
//     case USER_DETAILS_RESET:
//       return {user:{}}
//     default:
//       return state;
//   }
// };

